import React from 'react'
import { theme } from '~shared/muiTheme'
import { useTranslation } from 'react-i18next'
import DataProtectionContentDE from './components/dataProtectionContentDE'
import DataProtectionContentEN from './components/dataProtectionContentEN'
import Button from '@mui/material/Button'
import ButtonGroup from '@mui/material/ButtonGroup'
import { availableLanguages } from '~shared/translations/i18next'
import { useHistory } from 'react-router-dom'
import { Container, Paper } from '@mui/material'

const DataProtection: React.FC = () => {
  const { i18n, t } = useTranslation()
  const history = useHistory()

  const changeLanguage = (lngCode: string) => () => {
    i18n.changeLanguage(lngCode)
  }

  // todo - we should use i18n translation file - it was just to much for the time available
  return <div style={{ height: '100vh', overflowY: 'scroll' }}>
    <Container
      maxWidth='md'
      style={{ marginTop: theme.spacing(2), marginBottom: theme.spacing(2) }}
    >
      <ButtonGroup
        variant='contained'
        color='secondary'
        aria-label='contained primary button group'
        style={{ marginBottom: theme.spacing(2) }}
      >
        <Button onClick={() => history.goBack()}>{t('form:back')}</Button>
        {
          availableLanguages.map((language, i) => {
            return (
              <Button
                key={i}
                onClick={changeLanguage(language.code)}
              >
                {language.name}
              </Button>
            )
          })
        }
      </ButtonGroup>
      <Paper elevation={3} style={{ padding: theme.spacing(2) }}>
        {
          (i18n.language === 'en' && <DataProtectionContentEN />)
          || <DataProtectionContentDE />
        }
      </Paper>
    </Container>
  </div>
}

export default DataProtection
